import type {Sector} from "crqlar-react-common/dist/models/sector/sector.model";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import type {ReactElement} from "react";
import {PageShell, type TabRoute} from "../layout/PageShell";
import {ReservationCalendar} from "./ReservationCalendar";
import OtherReservationList from "./lists/OtherReservationList";

interface Props {
    appName: string;
    icon: ReactElement;
    tabPath: (tab: string) => string;
    sector: Sector;
}

export default function Other({appName, icon, tabPath, sector}: Props) {
    const {t} = useLocalize();

    const tabs: TabRoute[] = [
        {
            path: tabPath("calendar"),
            label: t("Calendar"),
            render: () => sector.id ? <ReservationCalendar sector={sector}/> : null,
        },
        {
            path: tabPath("list"),
            label: t("List"),
            render: () => sector.id ? <OtherReservationList sectorId={sector.id}/> : null,
        },
    ];

    return (
        <PageShell
            icon={icon}
            title={appName}
            documentTitle={appName}
            tabs={tabs}
        />
    );
}
